module.exports = __webpack_public_path__ + "img/canada-eye-and-ear-diseases-male.34d4c8bb.png";